import { render } from "./Loading.vue?vue&type=template&id=42b57ff3&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=ts"
export * from "./Loading.vue?vue&type=script&lang=ts"

import "./Loading.vue?vue&type=style&index=0&id=42b57ff3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-42b57ff3"

export default script